import React from 'react';
import NavBar from '../NavBar';

/**
 * Общая оболочка страниц владельца / кассы / финансов.
 */
export default function OwnerPageLayout({
    title,
    subtitle,
    actions,
    beforeMain,
    children,
    maxWidth = 1200,
    className = ''
}) {
    return (
        <div className={`sp-page ${className}`.trim()}>
            <NavBar />
            {beforeMain}
            <main className="sp-page__main" style={{ maxWidth }}>
                {title && <h1 className="sp-page__title">{title}</h1>}
                {(subtitle || actions) && (
                    <header className="sp-page__header sp-page__header--toolbar-only">
                        <div className="sp-page__header-text">
                            {subtitle && <p className="sp-page__subtitle">{subtitle}</p>}
                        </div>
                        {actions && <div className="sp-page__actions">{actions}</div>}
                    </header>
                )}
                {children}
            </main>
        </div>
    );
}
